import { render, staticRenderFns } from "./basicDocAndService.vue?vue&type=template&id=a52603d8"
import script from "./basicDocAndService.vue?vue&type=script&lang=js"
export * from "./basicDocAndService.vue?vue&type=script&lang=js"
import style0 from "./basicDocAndService.vue?vue&type=style&index=0&id=a52603d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports